import { all, put, takeLatest } from "redux-saga/effects";

import store from "../../store/store";
import {
  hideLoader,
  showLoader,
} from "../../component-lib/Molecules/loader/LoaderSlice";

import { eventEHRCustomToastMessage } from "../../component-lib/Atoms/custom-toast-message/EventEHRCustomToastMessage";
import DashboardService from "../../services/DashboardService";
import {
  componentKey,
  setDashboardData,
  setDashboardGraphData,
  setDataForFacility,
  setFacilityDashboardData,
  setFacilityRooms,
  setIcdSummary,
} from "./DashboardSlice";

export const {
  getDashboardData,
  getDashboardGraph,
  getDataForFacilities,
  getFacilityRooms,
  getIcdSummary,
} = {
  getDashboardData: (payload) => {
    return {
      type: "DASHBOARD/GET_DASHBOARD_DATA",
      payload,
    };
  },
  getDashboardGraph: (payload) => {
    return {
      type: "DASHBOARD/GET_DASHBOARD_GRAPH",
      payload,
    };
  },
  getDataForFacilities: (payload) => {
    return {
      type: "DASHBOARD/GET_FACILITY_DATA",
      payload,
    };
  },
  getFacilityRooms: (payload) => {
    return {
      type: "DASHBOARD/GET_FACILITY_ROOMS",
      payload,
    };
  },
  getIcdSummary: (payload) => {
    return {
      type: "DASHBOARD/GET_ICD_SUMMARY",
      payload,
    };
  },
};

// GET DASHBOARD API CALL FUNCTION
function* getDashboardDataAsync(action) {
  // Silent polling (auto-refresh) skips the global loader.
  const silent = action?.payload?.silent;
  try {
    if (!silent) yield put(showLoader());
    const response = yield DashboardService.getDashboardData(action?.payload);
    const { status } = response;
    if (status) {
      const { data } = response;
      yield put(setDashboardData(data));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setDashboardData({}));

    console.log("err: ", error);
  } finally {
    if (!silent) yield put(hideLoader());
  }
}

// GET DASHBOARD API CALL FUNCTION
function* getDashboardGraphAsync(action) {
  try {
    yield put(showLoader());
    const response = yield DashboardService.getDashboardGraph(action?.payload);
    const { status } = response;
    if (status) {
      const { data } = response;
      yield put(setDashboardGraphData(data));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setDashboardGraphData({}));

    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// GET FACILITY DASHBOARD API CALL FUNCTION
function* getFacilityDashboardAsync(action) {
  // Silent polling (auto-refresh) skips the global loader.
  const silent = action?.payload?.silent;
  try {
    if (!silent) yield put(showLoader());
    const response = yield DashboardService.getFacilityDashboardData(
      action?.payload?.payload
    );
    const { status } = response;
    if (status) {
      const { data } = response;
      yield put(setFacilityDashboardData(data));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    {
      yield put(setFacilityDashboardData({}));
    }
    console.log("err: ", error);
  } finally {
    if (!silent) yield put(hideLoader());
  }
}

// GET FACILITY ROOMS ASYNC (dashboard room assignments widget)
function* getFacilityRoomsAsync(action) {
  try {
    const response = yield DashboardService.getFacilityRooms(action?.payload);
    const { status, data } = response;
    if (status && data?.success) {
      yield put(setFacilityRooms(data?.rooms || []));
    }
  } catch (error) {
    yield put(setFacilityRooms([]));
    console.log("err: ", error);
  }
}

// GET ICD/DSM SUMMARY ASYNC (dashboard ICD codes widget)
// Never blocks the screen with the global loader — the card owns its own
// filter and refetches on every window change.
function* getIcdSummaryAsync(action) {
  try {
    const response = yield DashboardService.getIcdSummary(action?.payload);
    const { status, data } = response;
    if (status && data?.success) {
      yield put(setIcdSummary(data));
    }
  } catch (error) {
    yield put(setIcdSummary({}));
    console.log("err: ", error);
  }
}

function* rootSaga() {
  yield all([takeLatest(getDashboardData().type, getDashboardDataAsync)]);
  yield all([takeLatest(getDashboardGraph().type, getDashboardGraphAsync)]);
  yield all([
    takeLatest(getDataForFacilities().type, getFacilityDashboardAsync),
  ]);
  yield all([takeLatest(getFacilityRooms().type, getFacilityRoomsAsync)]);
  yield all([takeLatest(getIcdSummary().type, getIcdSummaryAsync)]);
}

store.sagaManager.addSaga(componentKey, rootSaga);
